module.exports = __webpack_public_path__ + "img/029.be0551fb.jpg";